import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import styles from './AgeGraph.module.css'

// Register the necessary components
ChartJS.register(ArcElement, Tooltip, Legend);

const AgeDoughnutChart = ({ data }) => {
    const ageList = data.ageGroup || [];

    // Prepare data for the chart
    const config = {
        labels: ageList.map(age => age._id),
        datasets: [
            {
                label: 'Age Group Distribution',
                data: ageList.map(age => age.count),
                backgroundColor: [
                    'rgba(255, 127, 80, 0.6)',  // Light Coral
                    'rgba(106, 90, 205, 0.6)',  // Slate Blue
                    'rgba(60, 179, 113, 0.6)',  // Medium Sea Green
                    'rgba(218, 165, 32, 0.6)',  // Goldenrod
                    'rgba(255, 99, 71, 0.6)',   // Tomato
                ],
                borderColor: [
                    'rgba(255, 127, 80, 1)',    // Light Coral
                    'rgba(106, 90, 205, 1)',    // Slate Blue
                    'rgba(60, 179, 113, 1)',    // Medium Sea Green
                    'rgba(218, 165, 32, 1)',    // Goldenrod
                    'rgba(255, 99, 71, 1)',     // Tomato
                ],
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Age Group Distribution',
            },
        },
    };

    return (
        <div className={styles.chart_wrap}>
            <Doughnut data={config} options={options} />
        </div>
    )
};

export default AgeDoughnutChart;